<mat-toolbar class="main-header">
  @if (sidenav.mode === "over") {
    <button mat-icon-button (click)="toggleMenu()">
      @if (!sidenav.opened) {
        <mat-icon> menu </mat-icon>
      }
      @if (sidenav.opened) {
        <mat-icon> close </mat-icon>
      }
    </button>
  }
  <span>Reglas</span>
</mat-toolbar>

<div class="rules-page">
  <section class="rules-hero">
    <div class="rules-hero-bg"></div>
    <div class="rules-hero-content">
      <span class="rules-kicker">Guía oficial</span>
      <h1>Reglas del juego</h1>
      <p>
        Todo lo que necesitas para sumar más puntos con tus pronósticos en cada
        fase del torneo.
      </p>
    </div>
  </section>

  <nav class="rules-index">
    <a href="#puntuacion" (click)="scrollToSection('puntuacion', $event)"
      >Puntuación</a
    >
    <a href="#jokers" (click)="scrollToSection('jokers', $event)">Jokers</a>
    <a href="#fases" (click)="scrollToSection('fases', $event)">Fases</a>
    <a href="#extra" (click)="scrollToSection('extra', $event)">Extras</a>
    <a href="#desempate" (click)="scrollToSection('desempate', $event)"
      >Desempate</a
    >
  </nav>

  <section class="rules-card rules-intro">
    <p>
      El juego consiste en pronosticar <b>todos</b> los resultados del torneo.
      Quien más resultados acierte, gana. Se puntúan dos tipos de aciertos: el
      pronóstico (1X2) y el resultado exacto (goles). Al principio del juego
      también deberás pronosticar el <b>Campeón</b> y el <b>Pichichi</b>.
    </p>
  </section>

  <section class="rules-card rules-anchor" id="puntuacion">
    <h2>Puntuaciones básicas</h2>
    <ul>
      <li>Pronóstico acertado (1X2): 3 puntos.</li>
      <li>Resultado exacto: 2 puntos extra.</li>
      <li>Dieciseisavos, octavos y cuartos multiplican la puntuación por 2.</li>
      <li>
        Semifinales, tercer puesto y final multiplican la puntuación por 3.
      </li>
      <li>
        En eliminatorias, el 1X2 corresponde al equipo que se clasifica. Si hay
        empate, lo decide el ganador de los penaltis.
      </li>
      <li>Campeón del torneo: 10 puntos.</li>
      <li>Pichichi del torneo: 15 puntos.</li>
    </ul>
    <p class="rules-note">
      Nota: los multiplicadores de ronda también se aplican al resultado exacto.
    </p>
  </section>

  <section class="rules-card rules-anchor" id="jokers">
    <h2>Jokers</h2>
    <p>
      Los <b>Jokers</b> hacen que la puntuación en el partido elegido se
      <b>duplique</b>. Dispones de {{ maxMatchJokers }} en total y su coste
      varía según la fase.
    </p>
    <ul>
      <li>
        Partido de fase de grupos: consume 1 Joker (Máximos puntos: 6 por
        pronóstico + 4 por resultado exacto).
      </li>
      <li>
        Partido de dieciseisavos, octavos o cuartos: consume 2 Jokers (Máximos
        puntos: 12 por pronóstico + 8 por resultado exacto).
      </li>
      <li>
        Partido de semifinales, tercer puesto o final: consume 3 Jokers (Máximos
        puntos: 18 por pronóstico + 12 por resultado exacto).
      </li>
    </ul>
    <p>
      Los Jokers de partidos deben colocarse antes de que empiece cada ronda.
      No se pueden usar Jokers en campeón ni en pichichi.
    </p>
    <h3>Ejemplos de uso</h3>
    <ul>
      <li>
        {{ maxMatchJokers }} Jokers en {{ maxMatchJokers }} partidos de fase de
        grupos (10 x 1 = 10).
      </li>
      <li>
        6 partidos de fase de grupos y 2 partidos de dieciseisavos (6 x 1 + 2 x
        2 = 10).
      </li>
      <li>
        4 partidos de fase de grupos y 3 partidos de dieciseisavos (4 x 1 + 3 x
        2 = 10).
      </li>
      <li>
        4 partidos de fase de grupos y 2 partidos de semifinales (4 x 1 + 2 x 3
        = 10).
      </li>
      <li>
        2 partidos de fase de grupos, 1 partido de octavos y 2 partidos de
        rondas finales (2 x 1 + 1 x 2 + 2 x 3 = 10).
      </li>
      <li>
        1 partido de fase de grupos, 3 partidos de cuartos y 1 partido de la
        final (1 x 1 + 3 x 2 + 1 x 3 = 10).
      </li>
      <li>
        7 partidos de fase de grupos y 1 partido de la final (7 x 1 + 1 x 3 =
        10).
      </li>
    </ul>
  </section>

  <section class="rules-card rules-anchor" id="fases">
    <h2>Normas por fases</h2>
    <h3>Fase de grupos (72 partidos)</h3>
    <p>
      En esta fase hay 3 posibles resultados: victoria local, victoria visitante
      o empate. No hay prórroga ni penaltis.
    </p>
    <p>
      Debes introducir tus resultados en el apartado de pronósticos y, al cerrar
      la liguilla, completar las fases siguientes.
    </p>

    <h3>Eliminatorias (32 partidos)</h3>
    <p>
      En eliminatorias cuenta el resultado tras 90 minutos más prórroga. Si
      pronosticas empate, también debes indicar qué equipo pasa en penaltis.
    </p>
    <p>
      Si el partido acaba empatado tras la prórroga, puedes sumar puntos por el
      equipo que gana la tanda y por el resultado exacto. La diana del marcador
      suma aunque no aciertes quién pasa en penaltis.
    </p>

    <div class="rules-example">
      <p>
        <b>Ejemplo:</b> en un partido de octavos de final, Francia-Alemania
        termina 3-3 (tras prórroga) y pasa Francia en penaltis. Las
        puntuaciones incluyen el multiplicador x2 de esta ronda.
      </p>
      <ol type="a">
        <li>Pronosticar 3-3 y Francia clasificada: 10 puntos (6 + 4).</li>
        <li>Pronosticar 3-3 y Alemania clasificada: 4 puntos.</li>
        <li>Pronosticar 3-2 para Francia: 6 puntos.</li>
        <li>Pronosticar 1-1 y Francia clasificada: 6 puntos.</li>
        <li>Pronosticar 2-1 para Alemania: 0 puntos.</li>
      </ol>
    </div>
  </section>

  <section class="rules-card rules-anchor" id="extra">
    <h2>Puntos extra</h2>
    <p>
      Al inicio del juego, cada participante debe pronosticar el campeón del
      torneo. Si acierta, suma 10 puntos extra.
    </p>
    <p>
      También debe pronosticar el máximo goleador. Si acierta, suma 15 puntos
      extra. Si hay empate de goles entre varios jugadores, todos cuentan como
      pichichi válido.
    </p>
  </section>

  <section class="rules-card rules-anchor" id="desempate">
    <h2>Desempate</h2>
    <p>En caso de empate en el primer puesto, el orden de desempate será:</p>
    <ol>
      <li>Mayor número de resultados exactos en todo el torneo.</li>
      <li>Haber acertado el campeón del torneo.</li>
      <li>Haber acertado el pichichi.</li>
      <li>Mayor número de pronósticos 1X2 acertados.</li>
      <li>Mayor número de pronósticos 1X2 acertados en fase de grupos.</li>
    </ol>
    <p>
      Este criterio aplica solo al empate por el primer puesto. En caso de
      empate en segunda o tercera posición, los participantes empatados
      comparten plaza.
    </p>
  </section>

  <section class="rules-alert">
    <mat-icon>warning_amber</mat-icon>
    <p>
      En cada fase, todos los participantes deben enviar sus pronósticos antes
      de que comience. Una vez iniciada la fase, no se permiten cambios. Cada
      guardado envía un email de confirmación.
    </p>
  </section>
</div>
